module.exports = __webpack_public_path__ + "img/app store.6674212.svg";